import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

interface IVerifyUserProfilePinPayload {
  pin: string;
  user_id: string;
  clinic_id: string;
  booking_id: string;
  intent: "checkin" | "checkout";
  source: "VMS";
  created_by: "CM";
}

interface IVerifyUserProfilePinResponse {
  status: boolean;
  message?: string;
  data?: any;
}

export const useVerifyUserProfilePinAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (payload: IVerifyUserProfilePinPayload) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response = await axios
        .post(CUSTOMER_APIS?.VERIFY_PIN?.baseURL ?? "", payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IVerifyUserProfilePinResponse>) => {
          if (res?.data?.status) {
            return { status: true, message: res?.data?.message ?? "PIN verified" };
          }
          return { status: false, message: res?.data?.message ?? "PIN verification failed" };
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
          const message = (e?.response?.data as any)?.message ?? "PIN verification failed";
          return { status: false, message };
        });

      return response;
    } catch (e: any) {
      return { status: false, message: e.message };
    }
  }, []);

  return { execute };
};

